<div class="p-input-icon-right block">
  <p-autoComplete
    [(ngModel)]="search"
    [suggestions]="products"
    name="Search"
    placeholder="Search"
    (completeMethod)="handleSearch()"
    (onSelect)="goToProduct($event)"
    [panelStyleClass]="'mobile-centered-panel'"
    [appendTo]="'body'"
    class="w-full search-autocomplete"
  >
    <ng-template #item let-p>
      <div class="flex items-center gap-3 w-full">
        <img
          [src]="p.product_thumbnail?.full_path"
          [alt]="p.name"
          class="w-4rem h-4rem object-cover border-round shadow-2"
        />
        <div class="flex-1 min-w-0">
          <span class="font-bold name-ellipsis">{{ p.name }}</span>
          @if (!disablePrices && !hidePrices()) {
            <span class="text-sm text-color-secondary">
              @if (p.show_tier_prices_only && p.lowest_tier_prices_data?.price) {
                Starting at {{ p.lowest_tier_prices_data?.price || 0 | price | usdPipe }}
              } @else {
                {{ p.final_price | price | usdPipe }}
              }
            </span>
          }
        </div>
      </div>
    </ng-template>
  </p-autoComplete>
  @if (!isLoading) {
    <i class="pi pi-search input-icon-right"></i>
  }
</div>
